export const ROLES = {
  SUPER: "SUPER",
  ADMIN: "ADMIN",
  CLIENT: "CLIENT", // schools
  TEACHER: "TEACHER", // teachers
  PARENT: "PARENT", // parent
  STUDENT: "STUDENT", // student
  GUEST: "GUEST", // guest
};
